import { Spinner } from '@/shared/components/Spinner/Spinner';
import { StyledLoadingScan } from '../ScanUrl.styles';
import { StyledCol, StyledOrangeGradTitle, StyledText } from '@/shared/styles';
import { useTranslation } from 'react-i18next';
import { U1Status } from '@/shared/components/Status/U1Status';

export const LoadingScanResults: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledLoadingScan>
      <U1Status
        srMessage={`${t('free_tools.accessibility_checker.analyzing')} ${t(
          'free_tools.accessibility_checker.were_reviewing'
        )} ${t('free_tools.accessibility_checker.wont_take_long')}`}
      />
      <Spinner />
      <StyledCol $gap={12} $align="center">
        <StyledOrangeGradTitle $align="center">
          {t('free_tools.accessibility_checker.analyzing')}...
        </StyledOrangeGradTitle>
        <StyledText textAlign="center" fontSize="20px">
          {t('free_tools.accessibility_checker.were_reviewing')} <br />
          {t('free_tools.accessibility_checker.wont_take_long')}
        </StyledText>
      </StyledCol>
    </StyledLoadingScan>
  );
};
